import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

export const StyledFooter = styled(Box)({
  paddingTop: 32,
  marginTop: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,

  '@media (min-width: 640px)': {
    flexDirection: 'row',
    justifyContent: 'center',
  },
});
